import React from 'react';
import { Button, useColorMode } from '@chakra-ui/react';

const BuyNowButton = ({ onOpenModal }) => {
  const { colorMode } = useColorMode();
  return (
    <Button
      bg={colorMode === 'dark' ? '#fff' : null}
      color={colorMode === 'dark' ? '#141414' : null}
      variant="black"
      w="170px"
      py="22px"
      fontWeight="400"
      mb="30px"
      onClick={() => onOpenModal('purchase')}
    >
      Buy Now
    </Button>
  );
};

export default BuyNowButton;
